<template>
  <screen v-show="show" :screen-info="$t('footscan.show_ankles')" @skip="$emit('skip')">
    <img
      v-if="after"
      src="../../assets/FootScan/ankle-after-roll.svg"
      :alt="$t('footscan.show_ankles')"
    />
    <img
      v-else
      src="../../assets/FootScan/ankle-before-roll.svg"
      :alt="$t('footscan.show_ankles')"
    />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import { wait } from '@/modules/utils';

import Screen from '../common/Screen.vue';

export default {
  name: 'ShowAnkles',
  mixins: [autoNext],
  components: {
    Screen,
  },
  data: () => ({
    playThroughGap: 3,
    audioKey: 'foot_show_ankles',
    after: false,
  }),
  watch: {
    show(nv) {
      if (nv) {
        wait(2).then(() => {
          this.after = true;
        });
      }
    },
  },
};
</script>

<style scoped></style>
